import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AlertComponent } from './alert/alert.component';
import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DropdownMenuComponent } from './dropdown/dropdown-menu/dropdown-menu.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { FavoriteMenuComponent } from './favorite-menu/favorite-menu.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { ModalNotificacionAppComponent } from './modal-notificacion-app/modal-notificacion-app.component';
import { ModalCelularNotificacionAppComponent } from './modal-celular-notificacion-app/modal-celular-notificacion-app.component';
import { SelectComponent } from './select/select.component';
import { CopyClipboardComponent } from './copy-clipboard/copy-clipboard.component';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { CuentasRelacionadasComponent } from './cuentas-relacionadas/cuentas-relacionadas.component';
import { IconActionButtonComponent } from './icon-action-button/icon-action-button.component';
import { SharedPipesModule } from '@/pipes/shared-pipes.module';
import { CollapseComponent } from './collapse/collapse.component';
import { ModalComponent } from './modal/modal.component';
import { ModalDetallesComponent } from '@pages/reportes/qr-leidos/modal-detalles/modal-detalles.component';
import { InputComponent } from './input/input.component';
import { InputWithSuffixComponent } from './input-with-suffix/input-with-suffix.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ToggleComponent } from './toggle/toggle.component';
import { ImageCropEditorComponent } from './image-crop-editor/image-crop-editor.component';
import { TableSkeletonComponent } from './table-skeleton/table-skeleton.component';

@NgModule({
  declarations: [
    AlertComponent,
    ButtonComponent,
    CheckboxComponent,
    DropdownMenuComponent,
    DropdownComponent,
    FavoriteMenuComponent,
    MenuItemComponent,
    ModalDetallesComponent,
    ModalComponent,
    ModalNotificacionAppComponent,
    ModalCelularNotificacionAppComponent,
    SelectComponent,
    CollapseComponent,
    InputComponent,
    InputWithSuffixComponent,
    PaginatorComponent,
    ToggleComponent,
    ImageCropEditorComponent,
    TableSkeletonComponent,
    IconActionButtonComponent,
    CopyClipboardComponent,
    DynamicTableComponent,
    CuentasRelacionadasComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    SharedPipesModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    AlertComponent,
    ButtonComponent,
    CheckboxComponent,
    DropdownMenuComponent,
    DropdownComponent,
    FavoriteMenuComponent,
    MenuItemComponent,
    ModalDetallesComponent,
    ModalComponent,
    ModalNotificacionAppComponent,
    ModalCelularNotificacionAppComponent,
    SelectComponent,
    CollapseComponent,
    InputComponent,
    InputWithSuffixComponent,
    PaginatorComponent,
    ToggleComponent,
    ImageCropEditorComponent,
    TableSkeletonComponent,
    IconActionButtonComponent,
    CopyClipboardComponent,
    DynamicTableComponent,
    CuentasRelacionadasComponent,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule
  ]
})
export class SharedComponentsModule { }
